var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeApartments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 90,
    viewBox: "0 0 84 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10688",
    "data-name": "Group 10688",
    transform: "translate(-1610.961 -660.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10247",
    "data-name": "Path 10247",
    d: "M417.245,189.845A1.24,1.24,0,0,1,416,188.6V161.311a1.241,1.241,0,1,1,2.483,0V188.6A1.24,1.24,0,0,1,417.245,189.845Zm0,0",
    transform: "translate(1261.849 530.6)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10248",
    "data-name": "Path 10248",
    d: "M81.277,189.845a1.24,1.24,0,0,1-1.241-1.241V161.311a1.241,1.241,0,1,1,2.483,0V188.6A1.24,1.24,0,0,1,81.277,189.845Zm0,0",
    transform: "translate(1546.266 530.6)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10249",
    "data-name": "Path 10249",
    d: "M199.617,82.5h-22.34a1.241,1.241,0,0,1,0-2.483h22.34a1.241,1.241,0,1,1,0,2.483Zm0,0",
    transform: "translate(1464.872 598.684)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10250",
    "data-name": "Path 10250",
    d: "M199.617,450.491h-22.34a1.241,1.241,0,1,1,0-2.483h22.34a1.241,1.241,0,1,1,0,2.483Zm0,0",
    transform: "translate(1464.872 286.891)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    transform: "translate(1666.048 660.684)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    transform: "translate(1610.961 660.684)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    transform: "translate(1666.048 721.771)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(1610.961 721.771)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1671.88 667.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.365.365,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-2",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1671.88 728.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-2",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-2",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-2",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-2",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-2",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-2",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-2",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.365.365,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-2",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-3",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1616.793 728.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-3",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-3",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-3",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-3",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-3",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-3",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-3",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.365.365,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-3",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-4",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1616.793 667.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-4",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-4",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-4",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-4",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-4",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-4",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-4",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.365.365,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-4",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-5",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1634.035 688.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-5",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-5",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-5",
    "data-name": "Path 10228",
    d: "M37.842,41.249l-7.036-6.2c.008-.042.016-.085.025-.136v-8.1a.891.891,0,0,0-.847-.89H26.056a.87.87,0,0,0-.822.89v3.356l-5.63-4.95a.8.8,0,0,0-1.068,0L.3,41.24a.865.865,0,0,0-.107,1.2.8.8,0,0,0,1.159.11l.016-.017,17.7-15.544,6.337,5.569L29.2,35.875l7.586,6.662a.8.8,0,0,0,1.159-.093A.874.874,0,0,0,37.842,41.249Zm-8.663-7.628-2.3-2V27.628h2.3Z",
    transform: "translate(0.217 -24.799)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-5",
    "data-name": "Path 10228 - Outline",
    d: "M.787,42.929a1.013,1.013,0,0,1-.8-.389,1.088,1.088,0,0,1,.136-1.5L18.36,25.026a1.04,1.04,0,0,1,.682-.258,1.016,1.016,0,0,1,.677.259l5.266,4.63V26.783a1.09,1.09,0,0,1,1.04-1.108h3.937a1.111,1.111,0,0,1,1.057,1.1V34.9l0,.017,0,.019,6.943,6.114a1.1,1.1,0,0,1,.124,1.5,1.022,1.022,0,0,1-1.474.12L29.02,36.008l-3.789-3.322-6.193-5.442L1.458,42.682A1.048,1.048,0,0,1,.787,42.929ZM19.042,25.2a.6.6,0,0,0-.394.15L.406,41.376a.648.648,0,0,0-.076.892.579.579,0,0,0,.456.223.61.61,0,0,0,.383-.138l.021-.02L19.039,26.662l6.481,5.7,3.789,3.322,7.586,6.662a.588.588,0,0,0,.389.15.6.6,0,0,0,.457-.218.655.655,0,0,0-.075-.892L30.537,35.1l.024-.123c.007-.035.014-.071.021-.112V26.783a.674.674,0,0,0-.632-.671H26.025a.657.657,0,0,0-.6.671v3.839l-5.993-5.269A.58.58,0,0,0,19.042,25.2Zm10.325,8.864-2.738-2.38v-4.31h2.738Zm-2.3-2.579,1.864,1.62V27.815H27.065Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-5",
    "data-name": "Group 10618",
    transform: "translate(3.745 4.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-5",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-5",
    "data-name": "Path 10229",
    d: "M74.568,94.983l-2.293-1.954L60.061,82.613a.817.817,0,0,0-1.061,0L46.787,93.028l-2.293,1.954a.812.812,0,0,0-.09,1.148.8.8,0,0,0,1.126.1l.008-.008,1.02-.879v15.268a.86.86,0,0,0,.84.839H71.655a.854.854,0,0,0,.84-.839V95.341l1.02.879a.812.812,0,0,0,.522.2.826.826,0,0,0,.62-.285A.8.8,0,0,0,74.568,94.983ZM62.795,109.811H56.268v-8.794h6.527Zm1.632,0v-9.584a.812.812,0,0,0-.783-.839H55.419a.812.812,0,0,0-.783.839v9.584H48.19V93.949l11.341-9.641,11.341,9.641v15.863Z",
    transform: "translate(-43.99 -82.2)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-5",
    "data-name": "Path 10229 - Outline",
    d: "M59.5,82.168a1.025,1.025,0,0,1,.67.249L74.678,94.785a1.011,1.011,0,0,1,.363.7,1.025,1.025,0,0,1-.249.759,1.039,1.039,0,0,1-.786.361,1.027,1.027,0,0,1-.662-.246l-.662-.571v14.791a1.07,1.07,0,0,1-1.055,1.057H47.367a1.083,1.083,0,0,1-1.059-1.053v-14.8l-.668.577a1.028,1.028,0,0,1-1.679-.872,1.027,1.027,0,0,1,.359-.706l2.293-1.955L58.828,82.416A1.051,1.051,0,0,1,59.5,82.168Zm14.5,14a.61.61,0,0,0,.455-.209.591.591,0,0,0,.144-.437.579.579,0,0,0-.209-.4L72.1,93.163,59.888,82.748A.589.589,0,0,0,59.5,82.6a.612.612,0,0,0-.393.144L44.6,95.117a.594.594,0,0,0-.066.84.576.576,0,0,0,.812.079l.013-.012,1.381-1.191v15.745a.641.641,0,0,0,.626.62H71.624a.633.633,0,0,0,.622-.624V94.833l1.381,1.191A.593.593,0,0,0,74.006,96.166ZM59.5,83.989l11.559,9.827V110H64.176v-9.8a.6.6,0,0,0-.565-.62H55.388a.6.6,0,0,0-.565.62V110H47.94V93.816ZM70.622,94.018,59.5,84.562,48.377,94.018v15.543h6.009V100.2a1.032,1.032,0,0,1,1-1.057h8.224a1.032,1.032,0,0,1,1,1.057v9.366h6.009Zm-14.6,6.749h6.964V110H56.018Zm6.527.437h-6.09v8.357h6.09Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeApartments);
export default __webpack_public_path__ + "static/media/mergeApartments.50d3bd9ec2280e51a679831b1b09acbb.svg";
export { ForwardRef as ReactComponent };